var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-title"},[_c('Icon',{attrs:{"name":"arrow-back","color":_vm.color,"isClickable":""},on:{"click":_vm.handleClick}}),_c('Title',{staticClass:"title",attrs:{"level":_vm.level,"color":_vm.color}},[_vm._t("default")],2),(_vm.$slots.append)?_c('div',{staticClass:"back-title__append"},[_vm._t("append")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }